export default __webpack_public_path__ + "static/media/yourturn-games(mobile).c1b678ba.png";